import { Outlet, RouteObject } from 'react-router-dom'

import accountPortalRoutes from '~/app/providers/router/accountPortalRoutes'
import adminPortalRoutes from '~/app/providers/router/adminPortalRoutes'
import authRoutes from '~/app/providers/router/authRoutes'
import marketingRoutes from '~/app/providers/router/marketingRoutes'
import quotesRoutes from '~/app/providers/router/quotesRoutes'
import PageErrorBoundary from '~/components/pageErrorBoundary'
import GetAgentCentralizedProvider from '~/features/agents/components/getAgentCentralizedProvider'
import PartnerAuth from '~/features/partners/components/partnerLogin'
import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'
import AccountLayout from '~/layouts/account'
import AdminRestrictedLayout from '~/layouts/adminOutlet'
import AppLayout from '~/layouts/app'
import AuthLayout from '~/layouts/auth'
import ChatBotLayout from '~/layouts/chatbot'
import ConfigLayout from '~/layouts/configOutlet'
import RootConfigLayout from '~/layouts/rootConfig'
import SeoConfigLayout from '~/layouts/seo'
import { EClientPath } from '~/models/api'
import ChatBotPage from '~/pages/chatbot'
import ChatBotV2Page from '~/pages/chatbotV2'
import Help247Page from '~/pages/help247Page'
import HomePage from '~/pages/home'
import NotFoundPage from '~/pages/notFoundPage'
import OauthCallbackPage from '~/pages/scenarios/oauthCallback'
import UnsubscribePage from '~/pages/unsubscribe'

const routes: RouteObject[] = [
  {
    element: (
      <GetAgentCentralizedProvider>
        <RootConfigLayout />
      </GetAgentCentralizedProvider>
    ),
    children: [
      {
        element: <SeoConfigLayout />,
        children: [
          {
            path: EClientPath.help247,
            element: (
              <PageErrorBoundary>
                <Help247Page />
              </PageErrorBoundary>
            ),
          },
          {
            path: EClientPath.home,
            element: <HomePage />,
          },
          {
            element: <ConfigLayout />,
            children: [
              {
                element: <AuthLayout />,
                children: authRoutes,
              },
              {
                element: <AppLayout />,
                children: marketingRoutes,
              },
              {
                element: <AccountLayout />,
                children: accountPortalRoutes,
              },
              {
                element: <AdminRestrictedLayout />,
                children: adminPortalRoutes,
              },
            ],
          },
          {
            element: <ChatBotLayout />,
            children: [
              EClientPath.oldChat,
              EClientPath.legacyChat,
              EClientPath.chat,
              EClientPath.anything,
            ].map((path) => ({
              path,
              element: <ChatBotPage />,
            })),
          },
          {
            // Same layout/chrome as v1, separate route so v1's routes above
            // are never touched. Admin gating happens inside ChatBotV2Page
            // itself (see that file for why, not via AdminRestrictedLayout).
            element: <ChatBotLayout />,
            children: [
              {
                path: EClientPath.chatV2,
                element: <ChatBotV2Page />,
              },
            ],
          },
          {
            element: (
              <PartnerThemeWrapper>
                <PageErrorBoundary>
                  <NotFoundPage />
                </PageErrorBoundary>
              </PartnerThemeWrapper>
            ),
            path: EClientPath.notFound,
          },
          {
            element: <PartnerAuth />,
            path: EClientPath.partnerAuth,
          },
          {
            path: EClientPath.unsubscribe,
            element: (
              <PageErrorBoundary>
                <UnsubscribePage />
              </PageErrorBoundary>
            ),
          },
          {
            path: EClientPath.integrationsOauthCallback,
            element: (
              <PageErrorBoundary>
                <OauthCallbackPage />
              </PageErrorBoundary>
            ),
          },
          {
            element: (
              <PartnerThemeWrapper>
                <PageErrorBoundary>
                  <Outlet />
                </PageErrorBoundary>
              </PartnerThemeWrapper>
            ),
            children: quotesRoutes,
          },
        ],
      },
    ],
  },
]

export default routes
